import { axiosInstance, useApi } from '@fides/fides-react-components';
import { AxiosError, AxiosResponse } from 'axios';
import { TableParams } from 'core/interfaces/TableParams';
import { endpoints } from '../consts';
import { DebitParams, VersionInformation } from '../interfaces';
import { Currency } from '../models';

export const getEFT = (restUrl: string, params: TableParams | DebitParams): Promise<AxiosResponse> =>
  axiosInstance.get(restUrl, { baseURL: endpoints.EFTApiUrl, params });

export const getCurrencies = (): Promise<Currency[]> =>
  axiosInstance
    .get(`${endpoints.ARSApiUrl}/${endpoints.currencies}`)
    .then((response: AxiosResponse<Currency[]>) => response.data)
    .catch((error: AxiosError) => Promise.reject(error));

export const useFetchVersionInfo = (): VersionInformation => {
  const [response] = useApi<VersionInformation>({
    baseURL: endpoints.PortalApiUrl,
    url: endpoints.versionInformation,
  });
  return response.data;
};

export const getEftCurrencies = (): Currency[] => {
  const [{ response }] = useApi<Currency[]>({
    baseURL: endpoints.EFTApiUrl,
    url: endpoints.currencies,
  });
  return response?.data ?? [];
};
